import React from 'react';
import PropTypes from 'prop-types';

const DownloadPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M18.222 16.51l2.234-.001c.306 0 .544.258.544.576 0 .18-.07.349-.208.458L16.335 23.3a.54.54 0 0 1-.673 0l-4.456-5.758c-.245-.193-.27-.554-.084-.807a.507.507 0 0 1 .42-.227l2.236.003V5.577c0-.317.249-.575.555-.575L17.667 5c.306 0 .555.258.555.576V16.51zM4.3 24.955h23.4c.166 0 .3.114.3.255v1.535c0 .141-.134.256-.3.256H4.3c-.166 0-.3-.115-.3-.256V25.21c0-.14.134-.255.3-.255z"
    />
  );
};

DownloadPath.propTypes = {
  fill: PropTypes.string,
};

export default DownloadPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/interaction/download.jsx